// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Maryland Connector Sync processing node registration.
 */
import { registerPipelineNode } from '../../../core/pipeline-registry'
import { MarylandConnectorSyncAdminView } from './components/AdminView'
import { MarylandConnectorSyncWorkflowNode } from './components/WorkflowNode'

registerPipelineNode({
  id: 'processing.maryland-connector-sync',
  manifest: {
    id: 'processing.maryland-connector-sync',
    name: 'Maryland Connector Sync',
    category: 'processing',
    icon: 'RefreshCw',
    description: 'Trigger score pipelines for updated Maryland bills',
    order: 26,
  },
  WorkflowNode: MarylandConnectorSyncWorkflowNode,
  AdminConfig: MarylandConnectorSyncAdminView,
})
